import React from 'react';
import { AdminStampWrapper } from './styles';

interface IAdminStampProps {
  color?: string;
  name: string;
}

const AdminStamp: React.FC<IAdminStampProps> = ({ color = "#ffababf", name }) => {
  return (
    <AdminStampWrapper color={color}>
      {name}
    </AdminStampWrapper>
  )
}

export default AdminStamp
